import { reactive } from "vue"

export const confirmState = reactive({
  visible: false,
  title: "",
  description: "",
  confirmTitle: "",
  cancelTitle: "",
  confirmBtnClass: "",
  cancelBtnClass: "",
  resolve: null,
})

export function customConfirm({
  title,
  description = "",
  confirmTitle = "",
  cancelTitle = "",
  confirmBtnClass = "",
  cancelBtnClass = "",
}) {
  return new Promise((resolve) => {
    confirmState.resolve?.(false)
    confirmState.title = title
    confirmState.description = description
    confirmState.confirmTitle = confirmTitle
    confirmState.cancelTitle = cancelTitle
    confirmState.confirmBtnClass = confirmBtnClass
    confirmState.cancelBtnClass = cancelBtnClass
    confirmState.resolve = resolve
    confirmState.visible = true
  })
}
